import { ProductClassification } from 'enums';
import { useFetch } from 'hooks';
import { ProductConfig } from 'types/interfaces/merchant/ProductConfig';

interface ProductConfigFunctions {
  getProductConfigAsync: () => Promise<ProductConfig[] | null>;
}

export const useProductConfigFunctions = (): ProductConfigFunctions => {
  const { get } = useFetch();

  async function getProductConfigAsync(): Promise<ProductConfig[] | null> {
    const url = `/productconfig`;
    const res = await get(url);

    if (res.status !== 200) {
      throw new Error('Something went wrong');
    }

    const data = await res?.json();

    const products: ProductConfig[] =
      data?.map((item: any) => ({
        Classification: parseInt(item.classification) as ProductClassification,
        InterestFreeMonths: item.interestFreeMonths,
        TransactionLimitMin: item.transactionLimitMin,
        TransactionLimitMax: item.transactionLimitMax,
        Standard: item.standard,
        Advertise: item.advertise,
        Promotion: item.promotion,
        PromotionDateRange: undefined, // This field doesn't exist in API response, set to undefined
      })) || [];

    return !products || products.length === 0 ? null : products;
  }

  return {
    getProductConfigAsync,
  };
};

export default useProductConfigFunctions;
